export enum SidebarPopupSide {
  left = 'left',
  right = 'right',
}
